import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { AutenticacaoService } from 'src/app/services/autenticacao.service';
import { AdesaoService } from 'src/app/services/adesao.service';
import { filter } from 'rxjs/operators';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-header-adesao',
    templateUrl: './header-adesao.component.html',
    styleUrls: ['./header-adesao.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterModule]
})
export class HeaderAdesaoComponent implements OnInit {

  exibeBtnLogin: boolean = false;
  autenticado: boolean = false;
  credenciais: any = null;

  constructor(private router: Router, private route: ActivatedRoute, private autenticacao: AutenticacaoService, private adesao: AdesaoService) { 
    document.body.className = "app-adesao";

    this.credenciais = this.autenticacao.getCredenciais();
  }

  ngOnInit() {

    this.router.events
    .pipe( 
      filter(event => event instanceof NavigationEnd)
    )
    .subscribe((event:NavigationEnd) => {

      if(event.url.indexOf("/login") >= 0){
        this.exibeBtnLogin = false;
      }else{
        this.exibeBtnLogin = true;
      }

    });

    this.autenticado = this.autenticacao.isAuthenticated();

    this.autenticacao.userSubject.subscribe((credenciais: any) => {
      this.autenticado = this.autenticacao.isAuthenticated();
      this.credenciais = this.autenticacao.getCredenciais();
    });

  }

  sair(){
    this.autenticacao.logout();
    this.router.navigate(['/autenticacao/login']);
  }

}
